import React, { useEffect } from "react";
import { Form } from "react-bootstrap";
import { useGlobalState } from '../../components/globalStateProvider';
import { machineSNListSelectedAPI } from '../../api/api_definitions.js';

const CustomerListStats = ({ index, block }) => {
  const { updateStatsBlock } = useGlobalState();

  // Cambio cliente
  const handleChange = (e) => {
    const value = e.target.value;
    updateStatsBlock(index, "customerName", value);
    updateStatsBlock(index, "snMachine", ""); // reset seriale selezionato
  };

  // Memo API per evitare richieste duplicate
  const memoizedAPI = (() => {
    let cache = {};
    return async (machineFamily, customer) => {
      const key = `${machineFamily}_${customer}`;
      if (!cache[key]) {
        cache[key] = await machineSNListSelectedAPI(machineFamily, customer);
      }
      return cache[key];
    };
  })();

  // Carica SN list quando cambia cliente
  useEffect(() => {
    let isMounted = true;
    if (!block.customerName || block.customerName === "") return;

    memoizedAPI(block.machineFamily, block.customerName)
      .then((dataAPI) => {
        if (isMounted && dataAPI !== null) {
          updateStatsBlock(index, "listSNMachines", dataAPI.ListSNMachines); // corretto
        }
      })
      .catch((err) => console.log(err));

    return () => { isMounted = false };
  }, [block.customerName]);

  return (
    <Form.Select className="w-100 h-100"
      aria-label="Seleziona cliente"
      value={block.customerName}
      onChange={handleChange}
    >
      <option value="" disabled>Seleziona un cliente</option>
      {block.listCustomerMachines.map((item, i) => (
        <option value={item} key={i}>{item}</option>
      ))}
    </Form.Select>
  );
};

export default CustomerListStats;
